import { render, staticRenderFns } from "./ApparelBrandModal.vue?vue&type=template&id=650a1a64&scoped=true&"
import script from "./ApparelBrandModal.vue?vue&type=script&lang=js&"
export * from "./ApparelBrandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a1a64",
  null
  
)

export default component.exports